import { Component, ViewChild, OnInit } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { StatusBar, Splashscreen } from 'ionic-native';

import { DebugPage } from '../pages/debug/debug';
import { LoginPage } from '../pages/login/login';
import { ReceiptsPage } from '../pages/receipts/receipts';
import { UsersPage } from '../pages/users/users';

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;
  pages: Array<{title: string, component: any}> = [];

  constructor(public platform: Platform, public modalCtrl: ModalController) {
    this.initializeApp();
  }

  ngOnInit() {
    console.log('ngOnInit MyApp');

    this.initializePages();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.styleDefault();
      Splashscreen.hide();
    });
  }

  initializePages() {
    this.pages = [
      { title: 'Login', component: LoginPage },
      { title: 'Users', component: UsersPage },
      { title: 'Receipts', component: ReceiptsPage },
      { title: 'Debug', component: DebugPage },
    ];
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component)
      .catch(() => {
        console.error('UNAUTHORIZED');
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts